import React from 'react';
import { func, number, string, bool } from 'prop-types';
import { Heart } from '@magalu/stereo-ui-icons';
import { NumberedButton } from '../../atoms';
import { IconContainer } from './wishlist-counter-button.styles';

const WishlistCounterButton = ({
  amount,
  nullable,
  truncateAmountThreshold,
  backgroundColor,
  counterColor = '#db44a7',
  fontColor = '#fff',
  iconColor = '#fff',
  onClick
}) => /*#__PURE__*/React.createElement(NumberedButton, {
  amount,
  nullable,
  truncateAmountThreshold,
  backgroundColor,
  counterColor,
  fontColor,
  onClick
}, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(Heart, {
  color: iconColor
})));

process.env.NODE_ENV !== "production" ? WishlistCounterButton.propTypes = {
  amount: number.isRequired,
  nullable: bool,
  truncateAmountThreshold: number,
  backgroundColor: string,
  counterColor: string,
  fontColor: string,
  iconColor: string,
  onClick: func
} : void 0;
WishlistCounterButton.defaultProps = {
  amount: 0,
  onClick: () => {},
  nullable: true
};
export default WishlistCounterButton;